import { TestingIBOPreview } from "./TestingIBOPreview";

export default TestingIBOPreview;
